// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.Suppress
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.guarantor.GuarantorApplicationPayload
import org.mifos.mobile.core.model.entity.guarantor.GuarantorPayload
import org.mifos.mobile.core.model.entity.guarantor.GuarantorTemplatePayload

@OptIn(InternalKtorfitApi::class)
public class _GuarantorServiceImpl(
  private val _ktorfit: Ktorfit,
) : GuarantorService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getGuarantorTemplate(loanId: Long): Flow<GuarantorTemplatePayload> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/guarantors/template")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<GuarantorTemplatePayload>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getGuarantorList(loanId: Long): Flow<List<GuarantorPayload>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/guarantors")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<List<GuarantorPayload>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun createGuarantor(loanId: Long, payload: GuarantorApplicationPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/guarantors")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun updateGuarantor(
    payload: GuarantorApplicationPayload?,
    loanId: Long,
    guarantorId: Long,
  ): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("PUT")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/guarantors/${"$guarantorId".encodeURLPath()}")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun deleteGuarantor(loanId: Long, guarantorId: Long): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/guarantors/${"$guarantorId".encodeURLPath()}")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _GuarantorServiceProvider : ClassProvider<GuarantorService> {
  override fun create(_ktorfit: Ktorfit): GuarantorService = _GuarantorServiceImpl(_ktorfit)
}

public fun Ktorfit.createGuarantorService(): GuarantorService = _GuarantorServiceImpl(this)
